"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileUpload_1 = require("./FileUpload");
exports.FileUpload = FileUpload_1.FileUpload;
//# sourceMappingURL=index.js.map